'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { useContext } from 'react';
import { LinkContext } from '../../../util/LinkContext.js';

const Link = ({ children, href, passHref = true }) => {
  const NextLink = useContext(LinkContext);
  if (NextLink) {
    return /* @__PURE__ */ jsx(NextLink, { href, passHref, legacyBehavior: true, children });
  }
  return /* @__PURE__ */ jsx(Fragment, { children: React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === "a") {
      const childProps = child.props;
      return /* @__PURE__ */ jsx("a", { ...childProps, href, children: childProps.children });
    }
    return child;
  }) });
};

export { Link as default };
//# sourceMappingURL=Link.js.map
